import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AdminGuard from './components/AdminGuard';
import AdminAuth from './pages/AdminAuth';
import AdminHub from './pages/AdminHub';
import AdminEditor from './pages/AdminEditor';
import AdminSecurity from './pages/AdminSecurity';
import { ToastProvider } from './components/Toast';
import './styles.css';
import { initTheme } from './lib/theme';

initTheme();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/setup" element={<AdminAuth mode="setup" />} />
          <Route path="/admin/login" element={<AdminAuth mode="login" />} />
          <Route
            path="/admin"
            element={
              <AdminGuard>
                <AdminHub />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/security"
            element={
              <AdminGuard>
                <AdminSecurity />
              </AdminGuard>
            }
          />
          <Route
            path="/admin/p/:id"
            element={
              <AdminGuard>
                <AdminEditor />
              </AdminGuard>
            }
          />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  </StrictMode>,
);
